const paginationMixin = loadMoreItemsMethod => ({
  data() {
    return {
      tablePagination: {
        page: 1,
        itemsPerPage: 10,
        pageStart: 0,
        pageStop: 0,
        pageCount: 0,
        itemsLength: 0
      }
    };
  },
  watch: {
    shouldLoadMoreItems() {
      this.loadMoreItemsCheck();
    }
  },
  computed: {
    currentPage() {
      return this.tablePagination.page;
    },
    totalPages() {
      return this.tablePagination.pageCount;
    },
    shouldLoadMoreItems() {
      if (this.totalPages == 0) return 0;

      return this.currentPage - this.totalPages;
    }
  },
  methods: {
    loadMoreItemsCheck() {
      if (this.shouldLoadMoreItems >= 0) this.loadMoreItems();
    },
    loadMoreItems() {
      this[loadMoreItemsMethod]();
    }
  }
});

export default paginationMixin;
